import React, { useEffect } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import clsx from "clsx";

import Header from "./Header";
import TabsSidebar from "./TabsSidebar";
import PopupInfo from "./PopupInfo";
import PopupInfoDetailTPRL from "./PopupInfoDetailTPRL";
import Footer from "./share-components/Footer";

import PriceBoard from "./PriceBoard";
import PriceBoardIndexBox from "./PriceBoardIndexBox";

import { constMarketCode, constUrlPathMenu, constTabName, TVSIPriceBoardHasAuth } from "../helpers/constData";
import { hidePopupInfo, hidePopupInfoTPRL } from "../redux/actions/sharedActions";
import Login from "./Login";
import { useApiCategoryStock } from "../helpers/apiCategoryStock";

export const Layout2 = (props) => {
  const tabRightMode = useSelector((state) => state.gShared.tabRightMode);

  return (
    <>
      <Header />
      <div className="main-body">
        <div className="main-left main-flex">
          {props.children}
          <Footer />
        </div>
        <div className={clsx("main-right", tabRightMode && tabRightMode === "FLOAT" ? "floating" : "")}>
          <TabsSidebar />
        </div>
      </div>
      <PopupInfo />
      <PopupInfoDetailTPRL />
    </>
  );
};

export const LayoutPriceBoard = (props) => {
  const dispatch = useDispatch();
  const apiCategoryStock = useApiCategoryStock();

  const tabRightMode = useSelector((state) => state.gShared.tabRightMode);
  const useDerivative = useSelector((state) => state.gShared.useDerivative);

  const isLoading = useSelector((state) => state.gShared.isLoading);
  const userName = useSelector((state) => state.gUser.userName ?? "");

  const handleClosePopup = (event) => {
    if (!event.target.id.includes("_code")) {
      hidePopupInfo(dispatch);
      hidePopupInfoTPRL(dispatch);
    }
  };

  useEffect(() => {
    // Event close popup
    getIpServerHide();
    const handleKeyPress = (event) => {
      if (event.key === "Escape" || event.keyCode === 27) {
        handleClosePopup(event);
      }
    };
    window.addEventListener("keydown", handleKeyPress);
    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };   
  }, []);

  useEffect(async () => {
    if (userName && userName !== "") {
      await getCategoryStock();
    }
  }, [userName]);

  const getIpServerHide = () => {
  // call api ẩn
    apiCategoryStock.GetIpServer()
    .then((res) => {})
    .catch((err) => {
    })
  };

  const getCategoryStock = async () => {
    const { data: loaded } = await apiCategoryStock.CategoryStock();
    dispatch({
      type: "GET_CATEGORY_STOCK",
      payload: loaded.arrCata,
    });
  };

  return TVSIPriceBoardHasAuth === "1" ? (
    userName && userName !== "" ? (
      <>
        {isLoading && (
          <div className="loading-container">
            <div className="loading-opacity"></div>
            <div className="circle-loading"></div>
            <div className="circle-loading-inner"></div>
          </div>
        )}
        {/* <Header/> */}
        <div className="main-body" onClick={(event) => handleClosePopup(event)}>
          <div className="main-left main-flex">
            <PriceBoardIndexBox />
            <Switch>
              {/* === MENU BANG GIA - TOP === */}

              <Route exact path="/banggia/top-incr-prc" render={(routeProps) => <PriceBoard {...routeProps} tabName={constTabName.TopTang} />} />
              <Route exact path="/banggia/top-incr-prc/hsx" render={(routeProps) => <PriceBoard {...routeProps} tabName={constTabName.TopTang_HSX} />} />
              <Route exact path="/banggia/top-incr-prc/hnx" render={(routeProps) => <PriceBoard {...routeProps} tabName={constTabName.TopTang_HNX} />} />
              <Route exact path="/banggia/top-incr-prc/upcom" render={(routeProps) => <PriceBoard {...routeProps} tabName={constTabName.TopTang_UpCOM} />} />

              <Route exact path="/banggia/top-decr-prc" render={(routeProps) => <PriceBoard {...routeProps} tabName={constTabName.TopGiam} />} />
              <Route exact path="/banggia/top-decr-prc/hsx" render={(routeProps) => <PriceBoard {...routeProps} tabName={constTabName.TopGiam_HSX} />} />
              <Route exact path="/banggia/top-decr-prc/hnx" render={(routeProps) => <PriceBoard {...routeProps} tabName={constTabName.TopGiam_HNX} />} />
              <Route exact path="/banggia/top-decr-prc/upcom" render={(routeProps) => <PriceBoard {...routeProps} tabName={constTabName.TopGiam_UpCOM} />} />

              <Route exact path="/banggia/top-vol" render={(routeProps) => <PriceBoard {...routeProps} tabName={constTabName.TopKL} />} />
              <Route exact path="/banggia/top-vol/hsx" render={(routeProps) => <PriceBoard {...routeProps} tabName={constTabName.TopKL_HSX} />} />
              <Route exact path="/banggia/top-vol/hnx" render={(routeProps) => <PriceBoard {...routeProps} tabName={constTabName.TopKL_HNX} />} />
              <Route exact path="/banggia/top-vol/upcom" render={(routeProps) => <PriceBoard {...routeProps} tabName={constTabName.TopGiam_UpCOM} />} />

              <Route exact path={constUrlPathMenu.TopNNMua} render={(routeProps) => <PriceBoard {...routeProps} tabName={constTabName.TopNNMua} />} />
              <Route exact path={constUrlPathMenu.TopNNMua_HSX} render={(routeProps) => <PriceBoard {...routeProps} tabName={constTabName.TopNNMua_HSX} />} />
              <Route exact path={constUrlPathMenu.TopNNMua_HNX} render={(routeProps) => <PriceBoard {...routeProps} tabName={constTabName.TopNNMua_HNX} />} />
              <Route exact path={constUrlPathMenu.TopNNMua_UpCOM} render={(routeProps) => <PriceBoard {...routeProps} tabName={constTabName.TopNNMua_UpCOM} />} />

              <Route exact path={constUrlPathMenu.TopNNBan} render={(routeProps) => <PriceBoard {...routeProps} tabName={constTabName.TopNNBan} />} />
              <Route exact path={constUrlPathMenu.TopNNBan_HSX} render={(routeProps) => <PriceBoard {...routeProps} tabName={constTabName.TopNNBan_HSX} />} />
              <Route exact path={constUrlPathMenu.TopNNBan_HNX} render={(routeProps) => <PriceBoard {...routeProps} tabName={constTabName.TopNNBan_HNX} />} />
              <Route exact path={constUrlPathMenu.TopNNBan_UpCOM} render={(routeProps) => <PriceBoard {...routeProps} tabName={constTabName.TopNNBan_UpCOM} />} />

              <Route exact path="/banggia/top" render={(routeProps) => <PriceBoard {...routeProps} tabName="TOP" />} />

              {/* === MENU MENU BANG GIA === */}
              <Route exact path="/banggia/hottrend" render={(routeProps) => <PriceBoard {...routeProps} tabName="HOT" />} />
              <Route exact path="/banggia/hsx" render={(routeProps) => <PriceBoard {...routeProps} marketCode={constMarketCode.HSX} isOddLot={false} />} />
              <Route exact path="/banggia/hsx/odd" render={(routeProps) => <PriceBoard {...routeProps} marketCode={constMarketCode.HSX} isOddLot={true} />} />
              <Route exact path="/banggia/hsx/thoathuan" render={(routeProps) => <PriceBoard {...routeProps} tabName={constTabName.ThoaThuan_HSX} />} />
              <Route exact path="/banggia/vn30" render={(routeProps) => <PriceBoard {...routeProps} marketCode={constMarketCode.HSX} indexCode="VN30" />} />
              <Route exact path="/banggia/hnx" render={(routeProps) => <PriceBoard {...routeProps} marketCode={constMarketCode.HNX} isOddLot={false} />} />
              <Route exact path="/banggia/hnx/odd" render={(routeProps) => <PriceBoard {...routeProps} marketCode={constMarketCode.HNX} isOddLot={true} />} />
              <Route exact path="/banggia/hnx/thoathuan" render={(routeProps) => <PriceBoard {...routeProps} tabName={constTabName.ThoaThuan_HNX} />} />
              <Route exact path="/banggia/hnx30" render={(routeProps) => <PriceBoard {...routeProps} marketCode={constMarketCode.HNX} indexCode="HNX30" />} />
              <Route exact path="/banggia/upcom" render={(routeProps) => <PriceBoard {...routeProps} marketCode={constMarketCode.UpCOM} />} isOddLot={false} />
              <Route exact path="/banggia/upcom/odd" render={(routeProps) => <PriceBoard {...routeProps} marketCode={constMarketCode.UpCOM} isOddLot={true} />} />
              <Route exact path="/banggia/upcom/thoathuan" render={(routeProps) => <PriceBoard {...routeProps} tabName={constTabName.ThoaThuan_UpCOM} />} />
              {/* {useDerivative === 'Y' ? (
                            <Route exact path="/banggia/phaisinh" render={(routeProps) => <PriceBoard {...routeProps} marketCode={constMarketCode.Derivative} />} />
                        ) : null} */}
              {/* <Route exact path="/banggia/thoathuan/all" render={(routeProps) => <PriceBoard {...routeProps} tabName={constTabName.ThoaThuan} />} />
              <Route exact path="/banggia/thoathuan/hsx" render={(routeProps) => <PriceBoard {...routeProps} tabName={constTabName.ThoaThuan_HSX} />} />
              <Route exact path="/banggia/thoathuan/hnx" render={(routeProps) => <PriceBoard {...routeProps} tabName={constTabName.ThoaThuan_HNX} />} />
              <Route exact path="/banggia/thoathuan/upcom" render={(routeProps) => <PriceBoard {...routeProps} tabName={constTabName.ThoaThuan_UpCOM} />} /> */}

              {/*  */}
              {/* <Route exact path="/banggia/phaisinh/vn30" render={(routeProps) => <PriceBoard {...routeProps} marketCode={constMarketCode.Derivative} underlying="vn30" />} />
              <Route exact path="/banggia/phaisinh/tpcp" render={(routeProps) => <PriceBoard {...routeProps} marketCode={constMarketCode.Derivative} />} /> */}

              <Route exact path="/banggia/nganh/:industryCode" render={(routeProps) => <PriceBoard {...routeProps} tabName="INDUSTRY" industryCode={routeProps.match.params.industryCode} />} />
              <Route exact path="/banggia/chungquyen" render={(routeProps) => <PriceBoard {...routeProps} tabName="CW" />} />
              {/* <Route exact path="/banggia/traiphieu" render={(routeProps) => <PriceBoard {...routeProps} marketCode={constMarketCode.Bond} />} /> */}
              <Route exact path="/banggia/fav" render={(routeProps) => <PriceBoard {...routeProps} tabName="FAV" />} />
              <Route exact path="/banggia/fav/:listid" render={(routeProps) => <PriceBoard {...routeProps} tabName="FAV" favListid={routeProps.match.params.listid} />} />
              <Route exact path="/banggia/tprl" render={(routeProps) => <PriceBoard {...routeProps} marketCode={constMarketCode.TPRL} />} />
              <Route exact path="/banggia/mo-rong" render={(routeProps) => <PriceBoard {...routeProps} tabName={constTabName.EXPAND} />} />
              <Route exact path="/banggia/tong-hop" render={(routeProps) => <PriceBoard {...routeProps} tabName={constTabName.TongHop} />} />
              <Redirect to="/banggia/vn30" />
            </Switch>
          </div>

          {/* <div className={clsx('main-right', (tabRightMode && tabRightMode === 'FLOAT' ? 'floating' : ''))}>
                    <TabsSidebar />
                </div> */}
        </div>
        <PopupInfo />
        <PopupInfoDetailTPRL />

      </>
    ) : (
      <>
        {isLoading && (
          <div className="loading-container">
            <div className="loading-opacity"></div>
            <div className="circle-loading"></div>
            <div className="circle-loading-inner"></div>
          </div>
        )}
        <Switch>
          <Route
            exact
            path="/login"
            render={(routeProps) => {
              return <Login />;
            }}
          />
          <Redirect to="/login" />
        </Switch>
      </>
    )
  ) : (
    <>
      {isLoading && (
        <div className="loading-container">
          <div className="loading-opacity"></div>
          <div className="circle-loading"></div>
          <div className="circle-loading-inner"></div>
        </div>
      )}
      {/* <Header/> */}
      <div className="main-body" onClick={(event) => handleClosePopup(event)}>
        <div className="main-left main-flex">
          <PriceBoardIndexBox />
          <Switch>
            {/* === MENU BANG GIA - TOP === */}
            <Route exact path="/banggia/top-incr-prc" render={(routeProps) => <PriceBoard {...routeProps} tabName={constTabName.TopTang} />} />
            <Route exact path="/banggia/top-incr-prc/hsx" render={(routeProps) => <PriceBoard {...routeProps} tabName={constTabName.TopTang_HSX} />} />
            <Route exact path="/banggia/top-incr-prc/hnx" render={(routeProps) => <PriceBoard {...routeProps} tabName={constTabName.TopTang_HNX} />} />
            <Route exact path="/banggia/top-incr-prc/upcom" render={(routeProps) => <PriceBoard {...routeProps} tabName={constTabName.TopTang_UpCOM} />} />

            <Route exact path="/banggia/top-decr-prc" render={(routeProps) => <PriceBoard {...routeProps} tabName={constTabName.TopGiam} />} />
            <Route exact path="/banggia/top-decr-prc/hsx" render={(routeProps) => <PriceBoard {...routeProps} tabName={constTabName.TopGiam_HSX} />} />
            <Route exact path="/banggia/top-decr-prc/hnx" render={(routeProps) => <PriceBoard {...routeProps} tabName={constTabName.TopGiam_HNX} />} />
            <Route exact path="/banggia/top-decr-prc/upcom" render={(routeProps) => <PriceBoard {...routeProps} tabName={constTabName.TopGiam_UpCOM} />} />

            <Route exact path="/banggia/top-vol" render={(routeProps) => <PriceBoard {...routeProps} tabName={constTabName.TopKL} />} />
            <Route exact path="/banggia/top-vol/hsx" render={(routeProps) => <PriceBoard {...routeProps} tabName={constTabName.TopKL_HSX} />} />
            <Route exact path="/banggia/top-vol/hnx" render={(routeProps) => <PriceBoard {...routeProps} tabName={constTabName.TopKL_HNX} />} />
            <Route exact path="/banggia/top-vol/upcom" render={(routeProps) => <PriceBoard {...routeProps} tabName={constTabName.TopGiam_UpCOM} />} />

            <Route exact path={constUrlPathMenu.TopNNMua} render={(routeProps) => <PriceBoard {...routeProps} tabName={constTabName.TopNNMua} />} />
            <Route exact path={constUrlPathMenu.TopNNMua_HSX} render={(routeProps) => <PriceBoard {...routeProps} tabName={constTabName.TopNNMua_HSX} />} />
            <Route exact path={constUrlPathMenu.TopNNMua_HNX} render={(routeProps) => <PriceBoard {...routeProps} tabName={constTabName.TopNNMua_HNX} />} />
            <Route exact path={constUrlPathMenu.TopNNMua_UpCOM} render={(routeProps) => <PriceBoard {...routeProps} tabName={constTabName.TopNNMua_UpCOM} />} />

            <Route exact path={constUrlPathMenu.TopNNBan} render={(routeProps) => <PriceBoard {...routeProps} tabName={constTabName.TopNNBan} />} />
            <Route exact path={constUrlPathMenu.TopNNBan_HSX} render={(routeProps) => <PriceBoard {...routeProps} tabName={constTabName.TopNNBan_HSX} />} />
            <Route exact path={constUrlPathMenu.TopNNBan_HNX} render={(routeProps) => <PriceBoard {...routeProps} tabName={constTabName.TopNNBan_HNX} />} />
            <Route exact path={constUrlPathMenu.TopNNBan_UpCOM} render={(routeProps) => <PriceBoard {...routeProps} tabName={constTabName.TopNNBan_UpCOM} />} />

            <Route exact path="/banggia/top" render={(routeProps) => <PriceBoard {...routeProps} tabName="TOP" />} />

            {/* === MENU MENU BANG GIA === */}
            <Route exact path="/banggia/hottrend" render={(routeProps) => <PriceBoard {...routeProps} tabName="HOT" />} />
            <Route exact path="/banggia/hsx" render={(routeProps) => <PriceBoard {...routeProps} marketCode={constMarketCode.HSX} isOddLot={false} />} />
            <Route exact path="/banggia/hsx/odd" render={(routeProps) => <PriceBoard {...routeProps} marketCode={constMarketCode.HSX} isOddLot={true} />} />
            <Route exact path="/banggia/hsx/thoathuan" render={(routeProps) => <PriceBoard {...routeProps} tabName={constTabName.ThoaThuan_HSX} />} />
            <Route exact path="/banggia/vn30" render={(routeProps) => <PriceBoard {...routeProps} marketCode={constMarketCode.HSX} indexCode="VN30" />} />
            <Route exact path="/banggia/hnx" render={(routeProps) => <PriceBoard {...routeProps} marketCode={constMarketCode.HNX} isOddLot={false} />} />
            <Route exact path="/banggia/hnx/odd" render={(routeProps) => <PriceBoard {...routeProps} marketCode={constMarketCode.HNX} isOddLot={true} />} />
            <Route exact path="/banggia/hnx/thoathuan" render={(routeProps) => <PriceBoard {...routeProps} tabName={constTabName.ThoaThuan_HNX} />} />
            <Route exact path="/banggia/hnx30" render={(routeProps) => <PriceBoard {...routeProps} marketCode={constMarketCode.HNX} indexCode="HNX30" />} />
            <Route exact path="/banggia/upcom" render={(routeProps) => <PriceBoard {...routeProps} marketCode={constMarketCode.UpCOM} isOddLot={false} />} />
            <Route exact path="/banggia/upcom/odd" render={(routeProps) => <PriceBoard {...routeProps} marketCode={constMarketCode.UpCOM} isOddLot={true} />} />
            <Route exact path="/banggia/upcom/thoathuan" render={(routeProps) => <PriceBoard {...routeProps} tabName={constTabName.ThoaThuan_UpCOM} />} />
            {/* {useDerivative === 'Y' ? (
                        <Route exact path="/banggia/phaisinh" render={(routeProps) => <PriceBoard {...routeProps} marketCode={constMarketCode.Derivative} />} />
                    ) : null} */}
            <Route exact path="/banggia/thoathuan/all" render={(routeProps) => <PriceBoard {...routeProps} tabName={constTabName.ThoaThuan} />} />
            {/* <Route exact path="/banggia/thoathuan/hsx" render={(routeProps) => <PriceBoard {...routeProps} tabName={constTabName.ThoaThuan_HSX} />} />
            <Route exact path="/banggia/thoathuan/hnx" render={(routeProps) => <PriceBoard {...routeProps} tabName={constTabName.ThoaThuan_HNX} />} />
            <Route exact path="/banggia/thoathuan/upcom" render={(routeProps) => <PriceBoard {...routeProps} tabName={constTabName.ThoaThuan_UpCOM} />} /> */}

            {/*  */}
            {/* <Route exact path="/banggia/phaisinh/vn30" render={(routeProps) => <PriceBoard {...routeProps} marketCode={constMarketCode.Derivative} underlying="vn30" />} />
            <Route exact path="/banggia/phaisinh/tpcp" render={(routeProps) => <PriceBoard {...routeProps} marketCode={constMarketCode.Derivative} />} /> */}

            <Route exact path="/banggia/nganh/:industryCode" render={(routeProps) => <PriceBoard {...routeProps} tabName="INDUSTRY" industryCode={routeProps.match.params.industryCode} />} />
            <Route exact path="/banggia/chungquyen" render={(routeProps) => <PriceBoard {...routeProps} tabName="CW" />} />
            {/* <Route exact path="/banggia/traiphieu" render={(routeProps) => <PriceBoard {...routeProps} marketCode={constMarketCode.Bond} />} /> */}
            <Route exact path="/banggia/fav" render={(routeProps) => <PriceBoard {...routeProps} tabName="FAV" />} />
            <Route exact path="/banggia/tprl" render={(routeProps) => <PriceBoard {...routeProps} marketCode={constMarketCode.TPRL} />} />
            <Route exact path="/banggia/mo-rong" render={(routeProps) => <PriceBoard {...routeProps} tabName={constTabName.EXPAND} />} />
            <Route exact path="/banggia/tong-hop" render={(routeProps) => <PriceBoard {...routeProps} tabName={constTabName.TongHop} />} />
            <Redirect to="/banggia/vn30" />
          </Switch>
        </div>

        {/* <div className={clsx('main-right', (tabRightMode && tabRightMode === 'FLOAT' ? 'floating' : ''))}>
                <TabsSidebar />
            </div> */}
      </div>
      <PopupInfo />
      <PopupInfoDetailTPRL />

    </>
  );
};
